/**
 * Admin Backup page component.
 *
 * Route: `/admin/backup`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminBackupPage
 */

import SystemBackupManager from '@/components/admin/SystemBackupManager';

export default function AdminBackupPage() {
  return <SystemBackupManager />;
}
